module.exports = __webpack_public_path__ + "img/Icon_Stop.f0e87c8e.png";